<script>

    import Input from "./Input.svelte";
    
    export let settings;

    let readableValue = "None"
    
    const isValid = (value) => {
        return true
    }
    
    $: {
       
        if (readableValue == "None") {
            if ("style" in settings) {
                if ("background-image" in settings.style) {
                    readableValue = settings.style["background-image"].replace("url(", "")
                    readableValue = readableValue.substring(0, readableValue.length - 1)
                    console.log("setting initial readable value!")
                }
            }
        }

        if (readableValue != "None") {
            settings.style["background-image"] = `url(${readableValue})`
        }

        console.log("readable value", readableValue)
    }
    
    </script>
    
    <div class="input-wrap">
        <input class="input inspector"  bind:value={readableValue}/>
    </div>
    
    
    <style>
    
    
    
    </style>